import CONTACT_CENTER from './animation_loader-contactcenter.json';
import BUBBLE from './animation_loader_bubble.json';
import PRIMARY from './animation_loader_primary.json';
import SECONDARY from './animation_loader_secondary.json';
import TERTIARY_ON_SURFACE from './animation_loader_tertiary-onsurface.json';
import TERTIARY_TECH_ONLY from './animation_loader_tertiary-techonly.json';
import TERTIARY from './animation_loader_tertiary.json';
export const animations = {
    primary: PRIMARY,
    secondary: SECONDARY,
    tertiary: TERTIARY,
    tertiaryOnSurface: TERTIARY_ON_SURFACE,
    tertiaryTechOnly: TERTIARY_TECH_ONLY,
    bubble: BUBBLE,
    contactCenter: CONTACT_CENTER,
    secondary_input: {},
};
//# sourceMappingURL=animations.js.map